export default __webpack_public_path__ + "static/media/utility10.ba54aa09.svg";